module.exports = __webpack_public_path__ + "img/HZ-S4016.1211cc7e.jpg";